export const STATUS_PENDING = 'STATUS_PENDING'
export const STATUS_SUCCESS = 'STATUS_SUCCESS'
export const STATUS_ERROR = 'STATUS_ERROR'

export const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/tiff'
]
